import {
  PostCardFragmentFragment,
  RepostCardFragmentFragment,
  TournamentPostCardFragmentFragment,
} from '@/__generated__/graphql.ts';
import { useAuthInfo } from '@/routes/_app/use-auth-info.ts';
import { TournamentLabel } from '../post-label/tournament-label.tsx';
import { PostCardShareActionsMenu } from './post-card-actions/post-card-share-actions-menu.tsx';
import {
  postCardActions,
  postCardFooter,
  postCardLabels,
} from './post-card.css.ts';

export const PostCardFooter = ({
  post,
}: {
  post:
    | PostCardFragmentFragment
    | RepostCardFragmentFragment
    | TournamentPostCardFragmentFragment;
}) => {
  const me = useAuthInfo();

  const postContent =
    (post as RepostCardFragmentFragment)?.originalPost || post;

  const label =
    (postContent as unknown as TournamentPostCardFragmentFragment)?.tournament
      ?.label || undefined;

  const tournamentId = (
    postContent as unknown as TournamentPostCardFragmentFragment
  )?.tournament?.id;

  const isRepost = post.__typename === 'RePost';
  const isMyRepost =
    (isRepost && post.author?.id === me.id) ||
    (!isRepost && !!postContent.repostId);
  const repostId = isRepost ? post.id : postContent.repostId;

  return (
    <div className={postCardFooter}>
      {label ? (
        <div className={postCardLabels} onClick={(e) => e.stopPropagation()}>
          <TournamentLabel
            label={label}
            tournamentId={tournamentId}
            linkToTournament
          />
        </div>
      ) : null}
      <div className={postCardActions} onClick={(e) => e.stopPropagation()}>
        <PostCardShareActionsMenu
          post={postContent}
          isMyRepost={isMyRepost}
          repostId={repostId}
        />
      </div>
    </div>
  );
};
